import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search } from 'lucide-react';
import axios from '../../utils/axios';

export default function GlobalSearchBar() {
    const navigate = useNavigate();
    const [query, setQuery] = useState('');
    const [results, setResults] = useState([]);
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const wrapRef = useRef(null);

    useEffect(() => {
        const onDoc = (e) => {
            if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', onDoc);
        return () => document.removeEventListener('mousedown', onDoc);
    }, []);

    useEffect(() => {
        const q = query.trim();
        if (q.length < 2) {
            setResults([]);
            return undefined;
        }
        const timer = setTimeout(async () => {
            setLoading(true);
            try {
                const res = await axios.get('/search', { params: { q, limit: 8 } });
                setResults(res.data?.data?.results || []);
                setOpen(true);
            } catch {
                setResults([]);
            } finally {
                setLoading(false);
            }
        }, 250);
        return () => clearTimeout(timer);
    }, [query]);

    const onPick = (item) => {
        setOpen(false);
        setQuery('');
        if (item.path) navigate(item.path);
    };

    return (
        <div ref={wrapRef} className="relative hidden md:block w-full max-w-xs lg:max-w-sm mx-2">
            <div className="relative">
                <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-[#9e9d9d]" />
                <input
                    type="search"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    onFocus={() => results.length && setOpen(true)}
                    placeholder="Search name, ID, invoice…"
                    className="w-full h-9 pl-9 pr-3 rounded-lg border border-[#e5edec] bg-[#f8fafa] text-sm text-[#383b50] placeholder:text-[#9e9d9d] focus:outline-none focus:ring-2 focus:ring-[#09b8a9]/30"
                />
            </div>
            {open && (loading || results.length > 0) && (
                <div className="absolute z-50 mt-1 w-full rounded-lg border border-[#e5edec] bg-white shadow-lg max-h-72 overflow-y-auto">
                    {loading && (
                        <p className="px-3 py-2 text-xs text-[#9e9d9d]">Searching…</p>
                    )}
                    {!loading && results.map((item) => (
                        <button
                            key={`${item.type}-${item.id}`}
                            type="button"
                            onClick={() => onPick(item)}
                            className="w-full text-left px-3 py-2 hover:bg-[#f4f6f6] border-b border-[#f0f3f3] last:border-0"
                        >
                            <p className="text-sm font-medium text-[#383b50]">{item.label}</p>
                            <p className="text-[11px] text-[#9e9d9d] capitalize">{item.type}{item.sublabel ? ` · ${item.sublabel}` : ''}</p>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
